import { IUseRefreshStoreArgs } from './types';

/**
 * currently on web this is a no-op.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function useRefreshStore(props: IUseRefreshStoreArgs) {}
